export default function MobileConfirm({ open, title, message, onConfirm, onCancel, confirmLabel = "Confirmar" }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" role="presentation">
      <button
        type="button"
        aria-label="Fechar"
        className="absolute inset-0 bg-black/60"
        onClick={onCancel}
      />
      <div
        role="dialog"
        aria-labelledby="mobile-confirm-title"
        aria-describedby="mobile-confirm-message"
        className="relative w-full max-w-sm rounded-2xl border border-primary bg-mgs-bg p-6 shadow-xl"
      >
        <h2 id="mobile-confirm-title" className="text-lg font-semibold text-laranjinha">
          {title}
        </h2>
        <p id="mobile-confirm-message" className="mt-2 text-sm text-laranjinha/70">
          {message}
        </p>
        <div className="mt-6 flex gap-3">
          <button
            type="button"
            onClick={onCancel}
            className="inline-flex min-h-[44px] flex-1 items-center justify-center rounded-lg border border-primary/50 bg-mgs-bg font-medium text-laranjinha hover:bg-monao"
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="inline-flex min-h-[44px] flex-1 items-center justify-center rounded-lg bg-red-700 font-medium text-white hover:bg-red-800"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
